export const SKILLS_LIST = [
  // Frontend
  "JavaScript", "TypeScript", "React", "Angular", "Vue.js", "HTML", "CSS", "Sass", "Bootstrap", "Tailwind CSS", "jQuery", "Next.js", "Nuxt.js",
  
  // Backend
  "Java", "Spring Boot", "Node.js", "Express.js", "Python", "Django", "Flask", "Go", "C#", "ASP.NET", "Ruby on Rails", "PHP", "Laravel", "Kotlin", "Rust",
  
  // Databases
  "SQL", "MySQL", "PostgreSQL", "MongoDB", "Oracle", "Redis", "Cassandra", "Firebase",
  
  // Cloud & DevOps
  "AWS", "Azure", "Google Cloud", "Docker", "Kubernetes", "Terraform", "CI/CD", "Jenkins", "Git", "GitHub", "GitLab", "CircleCI",
  
  // Mobile
  "React Native", "Flutter", "Swift", "Kotlin", "Android", "iOS",
  
  // Testing & QA
  "JUnit", "Mockito", "Selenium", "Cypress", "Jest", "Mocha", "Chai", "Postman", "Rest Assured",
  
  // Data & AI/ML
  "Python", "R", "TensorFlow", "PyTorch", "scikit-learn", "Pandas", "NumPy", "Matplotlib", "Seaborn", "Keras", "OpenCV",
  
  // Big Data
  "Hadoop", "Spark", "Kafka", "Hive",
  
  // Other / Misc
  "GraphQL", "REST API", "Microservices", "Agile", "Scrum", "Blockchain", "Solidity", "Figma", "Adobe XD", "SEO", "Cybersecurity", "Linux", "Bash"
];
